module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-shirts-large-95a3e693b1f0b6e7f5401adfbaaca185.jpg";